export default __webpack_public_path__ + "static/O0127-d58693ec89eb7cb93b0980d63fd54be4.png";